// extracted by mini-css-extract-plugin
export default {"mapBlock":"map_block_mapBlock__69L1l","mapAddressWrap":"map_block_mapAddressWrap__yMqHH","mapAddress":"map_block_mapAddress__tI0Ms","mapContainer":"map_block_mapContainer__JhKMY"};